import { Workstation } from "app/models/practice"
import { Action, Types } from "./workstations.actions"

export type WorkstationsState = {
  activeWorkstation: string | undefined
  errors: {}
  loading: boolean
  data: Workstation[]
}

const initialState: WorkstationsState = {
  activeWorkstation: undefined,
  data: [],
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): WorkstationsState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }
    case Types.POST:
      return {
        ...state,
        loading: true,
      }

    case Types.POST_SUCCESS:
      return {
        ...state,
        activeWorkstation: action.payload.data,
        loading: false,
      }

    case Types.POST_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.PUT:
      return {
        ...state,
        loading: true,
      }

    case Types.PUT_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case Types.PUT_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.PATCH_ORDER:
      return {
        ...state,
        loading: true,
      }

    case Types.PATCH_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case Types.PATCH_ORDER_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
